import { ActKc2GroupTypeEnum } from 'gql/graphql';
import { WorkOrderActsKc2ListTable } from 'pages/Project/Common/ActsKC2ListContainer';

import { useMemo } from 'react';

import { useUerActsKc2GroupManager, useUerActsKc2ListData } from './hooks';

const defaultColDef = {
    resizable: true,
    wrapHeaderText: true,
    spanHeaderHeight: true,
};

export const UerWorkOrderActsKc2ListTable = ({
    workOrderId,
    activeGroupTypeId,
    defaultOpenedSubGroup,
}: {
    workOrderId: number;
    activeGroupTypeId: ActKc2GroupTypeEnum | undefined | null;
    defaultOpenedSubGroup?: string;
}) => {
    const groupManagerAvailable = useMemo(() => activeGroupTypeId === ActKc2GroupTypeEnum.Custom, [activeGroupTypeId]);

    const {
        actKc2List,
        noRowsTemplate,
        refreshActListData,
        fetchedDataCount,
        tableColumns,
        totalItemsCount,
        isDeleteOpened,
        confirmDeletion,
        cancelDeletion,
        groupEditId,
        handlerCloseEditGroup,
        changeOrderHandler,
        handleTableSettingsConfirm,
        tableSettingsColumns,
        isColumnVisible,
    } = useUerActsKc2ListData({
        activeGroupTypeId,
        workOrderId,
        defaultOpenedSubGroup,
    });

    const {
        control,
        groupManagerColumns,
        groupManagerData,
        groupManagerOpened,
        handleToggleModalState,
        isLoading,
        handleSaveGroup,
        isCommit,
        isConfirmDisabled,
        isFormDirty,
    } = useUerActsKc2GroupManager({
        refreshActListData,
        actKC2GroupId: groupEditId,
        workOrderId,
        handlerCloseEditGroup,
    });

    return (
        <WorkOrderActsKc2ListTable
            groupManagerControl={control}
            actKc2List={actKc2List}
            tableColumns={tableColumns}
            groupManagerData={groupManagerData}
            groupManagerColumns={groupManagerColumns}
            groupManagerAvailable={groupManagerAvailable}
            isDeleteOpened={isDeleteOpened}
            confirmDeletion={confirmDeletion}
            cancelDeletion={cancelDeletion}
            groupManagerOpened={groupManagerOpened}
            handleSaveGroup={handleSaveGroup}
            defaultColDef={defaultColDef}
            handleToggleModalState={handleToggleModalState}
            isLoading={isLoading}
            isCommit={isCommit}
            isConfirmDisabled={isConfirmDisabled}
            isFormDirty={isFormDirty}
            noRowsTemplate={noRowsTemplate}
            fetchedDataCount={fetchedDataCount}
            totalItemsCount={totalItemsCount}
            changeDataOrderHandler={changeOrderHandler}
            isColumnVisible={isColumnVisible}
            tableSettingsColumns={tableSettingsColumns}
            handleTableSettingsConfirm={handleTableSettingsConfirm}
            isEdit={!!groupEditId}
            tableContext={{
                tableUniqueId: 'uerActList',
            }}
        />
    );
};

UerWorkOrderActsKc2ListTable.displayName = 'UerWorkOrderActsKc2ListTable';
